import React from 'react'
import Col from 'react-bootstrap/Col';
import { Card} from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import { BiWorld } from "react-icons/bi";
import { BiMoney } from "react-icons/bi";
import { BiPaperPlane } from "react-icons/bi";
import Profile from '../../assets/images/deepak-k.png';
import { BiLayer } from "react-icons/bi";

function Talentinfo() {
  return (
    <div className='talent_profile_detail_wrapper'>
    <h4>Talent information</h4>
                                <div class="talent_profile_detail">
                                    <div class="talent_profile_top">
                                        <Row className="align-items-center">
                                            <Col md={8} xs={12}>
                                                <div class="talent_profile">
                                                    <div className="talent_profile_img">
                                                    <img src={Profile} alt="Logo"/>     
                                                    </div>
                                                    <div className="talent_profile_content">
                                                        <span className="profile_active">Available</span>
                                                    <h5>Vitor Cezar D.</h5>
                                                    <p><i class="fa-solid fa-earth-americas me-2"></i>6 Overlapping hours
                                                        Campbell (GMT-7)</p>
                                                    
                                                    </div>                                    
                                                </div>
                                            </Col>
                                            <Col md={4} xs={12}>
                                                <div className="job_add_must_skill">                                    
                                                    <span><i class="fa-solid fa-trophy me-2"></i>Suggested match</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Row>
                                        <Col lg={4} md={6} xs={12}>
                                            <Card className='add_job_des_box'>
                                                <Card.Title>Home country</Card.Title>
                                                <Card.Text><BiWorld className='me-1'/>United States</Card.Text>                                                                      
                                            </Card>                                       
                                        </Col>
                                        <Col lg={4} md={6} xs={12}>
                                            <Card className='add_job_des_box'>
                                                <Card.Title>Current location</Card.Title>
                                                <Card.Text><BiPaperPlane className='me-1'/>Campbell, CA, USA (GMT-7)</Card.Text>                                                                      
                                            </Card>                                       
                                        </Col>
                                        <Col lg={4} md={6} xs={12}>
                                            <Card className='add_job_des_box'>
                                                <Card.Title>Talent bill rate (in USD)</Card.Title>
                                                <Card.Text><BiMoney className='me-1'/>$6,850.00</Card.Text>                                                                      
                                            </Card>                                       
                                        </Col>
                                        <Col md={12}>
                                            <Card className='add_job_des_box'>
                                                <Card.Title>Years of experience</Card.Title>
                                                <Card.Text><BiLayer className='me-1'/>8-12 yrs professional experience</Card.Text>                                                                      
                                            </Card>                                       
                                        </Col>
                                        <Col md={12}>
                                            <Card className='add_job_des_box'>
                                                <Card.Title>About</Card.Title>
                                                <Card.Text>--</Card.Text>                                                                      
                                            </Card>                                       
                                        </Col>
                                        <Col md={12}>
                                            <Card className='add_job_des_box'>
                                                <Card.Title>Skills</Card.Title>
                                                <Card.Text>--</Card.Text>                                                                      
                                            </Card>                                       
                                        </Col>
                                    </Row>                                                                       
                                </div> 
    </div>
  )
}

export default Talentinfo